import { Config, apiGet, apiPost, apiPut } from 'src/shared/utils/api-request';

export const getOrganizationDataAPI = async () => {
  console.trace();
  const config = {} as Config;
  config.custom = {
    setLoading: () => {}
  };
  const res = await apiGet('/admin/tenant');
  return res.data;
};

export const getTenantUserOrganizationDataAPI = async (userId: string) => {
  const res = await apiGet(`/user/${userId}/organizations`);
  return res.data;
};

// Add New Organization.
export const addOrganizationAPI = async (orgName: any) => {
  const res = await apiPost('/admin/tenant', orgName);
  return res.data;
};

export const updateOrganizationAPI = async (organization: any) => {
  const res = await apiPut('/admin/tenant/' + organization.id, {
    name: organization.tenantName
  });
  return res.data;
};

export const updateOrganizationPermissionAPI = async (payload: any) => {
  const res = await apiPut(
    '/access/tenant/' + payload.orgId + '/role/' + payload.role,
    {
      value: payload.flag
    }
  );
  return res.data;
};
export const getTenantPermissionDetailsAPI = async (payload: any) => {
  const res = await apiGet(
    `access/tenant/${payload.tenantId}/role/${payload.role}`
  );
  return res.data;
};
export const getAssetsFeatureListAPI = async (tenantId: string) => {
  const res = await apiGet(`/feature/tenants/${tenantId}`);
  return res.data;
};

export const addFeaturAPI = async (payload: any) => {
  const res = await apiPost('/feature', payload);
  return res.data;
};
